export default __webpack_public_path__ + "static/media/ChainedInLoveCover.ab346af1.jpeg";